import gsap from 'gsap';
import { validateEmail } from '../utils/validate';
import { logMixpanelEvent } from '../utils/mixpanel';

const PORTAL_ID = '8438483';
const FORM_ID = '536581bd-d980-4e0b-a18f-42f710bdef57';

export default class Modal {
  constructor(domElement) {
    this.dom = domElement;
    this.hidden = true;

    this.dom.userData = this;

    // timeline
    this.TL = gsap.timeline({ paused: true });
    this.TL.add(() => {
      document.body.classList.toggle('no-scroll');
    });
    this.TL.to(this.dom, { autoAlpha: 1, duration: 0.4 });

    this.init();
  }

  init() {
    document.addEventListener('keydown', ev => this.handleKeydown(ev));
    this.dom.querySelector('#modalSubmit').addEventListener('click', () => this.submit());
    this.dom.querySelector('#modalClose').addEventListener('click', () => this.hide());

    document.querySelector('#navRequest') &&
      document.querySelector('#navRequest').addEventListener('click', () => this.show());
    document.querySelector('#topperRequest') &&
      document.querySelector('#topperRequest').addEventListener('click', () => this.show());
    document.querySelector('#ctaRequest') &&
      document.querySelector('#ctaRequest').addEventListener('click', () => this.show());
    document.querySelector('#footerRequestSubmit') &&
      document.querySelector('#footerRequestSubmit').addEventListener('click', () => this.show());

    document.querySelector('#navRequest') &&
      document.querySelector('#modalClickMask').addEventListener('click', () => this.hide());
  }

  // exit the modal when user hits escape key
  handleKeydown(ev) {
    if (ev.key === 'Escape') {
      this.hide();
    }
  }

  show() {
    if (this.hidden) {
      // log open modal event
      logMixpanelEvent('Open modal');

      this.hidden = false;
      this.clear();
      gsap.set(this.dom.querySelector('#modalContentInner'), { autoAlpha: 1 });
      gsap.set(this.dom.querySelector('#modalSuccess'), { autoAlpha: 0 });
      this.TL.play();
    }
  }

  hide() {
    if (!this.hidden) {
      this.hidden = true;
      this.TL.reverse();
    }
  }

  clear() {
    this.dom.querySelector('#modalName').value = '';
    this.dom.querySelector('#modalEmail').value = '';
    this.dom.querySelector('#modalCompany').value = '';
    this.dom.querySelector('#modalComments').value = '';
  }

  submit() {
    const data = {
      fields: [
        {
          name: 'firstname',
          value: this.dom.querySelector('#modalName').value,
        },
        {
          name: 'email',
          value: this.dom.querySelector('#modalEmail').value,
        },
        {
          name: 'company',
          value: this.dom.querySelector('#modalCompany').value,
        },
        {
          name: 'message',
          value: this.dom.querySelector('#modalComments').value,
        },
      ],
      context: {
        pageUri: 'allpass.io',
        pageName: 'Allpass.io',
      },
    };

    if (!data.fields[0].value || !data.fields[1].value) {
      alert('Please fill out all the required fields.');
      return;
    }

    if (!validateEmail(data.fields[1].value)) {
      alert('Please enter a valid email address.');
      return;
    }

    fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(result => {
        if (result.status === 'error') {
          alert(result.errors[0].message);
        } else if (result.inlineMessage) {
          this.success(result.inlineMessage);
        }
      })
      .catch(error => {
        alert(error.message);
      });
  }

  success(result) {
    this.dom.querySelector('#modalSuccessMessage').innerHTML = result;

    // log submit event
    logMixpanelEvent('Submit email');

    // eslint-disable-next-line
    gtag_report_conversion(); // Google Ads tracking
    // eslint-disable-next-line
    gtag_request_demo_event(); // Google Analytics event

    // eslint-disable-next-line
    microsoftTrackDemoRequest(); // Microsoft tracking

    // LinkedIn conversion pixel
    const linkedInImg = document.createElement('img');
    linkedInImg.height = 1;
    linkedInImg.width = 1;
    linkedInImg.style = 'display:none;';
    linkedInImg.alt = '';
    linkedInImg.src =
      'https://px.ads.linkedin.com/collect/?pid=2691084&conversionId=2997612&fmt=gif';
    this.dom.querySelector('#linkedinpix').appendChild(linkedInImg);

    // capterra conversion pixel
    const capterraImg = document.createElement('img');
    capterraImg.height = 1;
    capterraImg.width = 1;
    capterraImg.style = 'display:none;';
    capterraImg.alt = '';
    capterraImg.src =
      'https://ct.capterra.com/capterra_tracker.gif?vid=2156826&vkey=3ff29b855a0be888cda7a17444042795';
    this.dom.querySelector('#capterrapx').appendChild(capterraImg);

    gsap.to(this.dom.querySelector('#modalContentInner'), {
      duration: 0.2,
      autoAlpha: 0,
    });
    gsap.to(this.dom.querySelector('#modalSuccess'), {
      duration: 0.2,
      autoAlpha: 1,
      delay: 0.2,
    });
  }
}
